import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { Package } from '../models';

export default function usePastImagesPricelists() {
  return useQuery({
    queryKey: [QueryKeys.pastImages, QueryKeys.pricelist],
    queryFn: () => (
      Package
        .selectExtra(['defaultBackgroundUrl'])
        .includes({ backgroundSet: 'backgrounds' })
        .where({ pastImages: true })
        .all()
        .then((res) => res.data)
    ),
    placeholderData: [],
  });
}
